// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zk7mQn71Jj5tV0E4kcjt {
  display: grid;
  grid-template-columns: 0.5fr 1fr 1fr;
  align-items: baseline;
  gap: 32px;
  margin: 20px 0;
}

.fEMoc0jwzCmobYDajppM {
  display: flex;
  gap: 8px;
  position: relative;
  top: 0;
  cursor: pointer;
}

.Cc2rQOPAT7e5Qqu9FHIA {
  font-family: var(--font-stack-full-regular);
  line-height: 1.5;
  font-size: 1rem;
  font-weight: 500;
  color: var(--grey-color-90);
}

.OIacJH1kyThUTLUqpATL {
  width: 100%;
  margin-top: 16px;
  padding-left: 12px;
}

.XneNLkMHBgtLi8K9pldq {
  margin-right: 16px;
}

.Xt_rNdVEwMNizYbDELEv {
  margin-bottom: 18px;
}

.Fw0Aw40WiDn9knvG9x0T {
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  font-family: var(--font-stack-full-medium);
  color: var(--grey-color-90);
}

.N12K7vA2yY09lFX2_TEL {
  height: 1px;
  margin-bottom: 24px;
  background-color: var(--grey-color-200);
}

.SKvMXPWWc6jlpZveTUTt {
  width: 100%;
  margin: 24px 0 12px;
  font-size: 20px;
  font-weight: 500;
  line-height: 32px;
  font-family: var(--font-stack-full-medium);
  display: grid;
  grid-template-columns: 0.5fr 1fr 1fr;
  align-items: baseline;
  gap: 32px;
}

.IR9oSF6_mJOa6ngiUsfS {
  flex: 1 1 48%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 32px;
}

.N0maLe28HIBDz6td7ncf {
  width: 50%;
}

.vhhHMETYuVS6TVaLkRDo {
  margin: 0 0 24px 0;
}`, "",{"version":3,"sources":["webpack://./src/components/ImmersiveAgilityDrilldownFactorChart/ImmersiveAgilityDrilldownFactorChart.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,oCAAA;EACA,qBAAA;EACA,SAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,kBAAA;EACA,MAAA;EACA,eAAA;AACF;;AAEA;EACE,2CAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,0CAAA;EACA,2BAAA;AACF;;AAEA;EACE,WAAA;EACA,mBAAA;EACA,uCAAA;AACF;;AAEA;EACE,WAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,0CAAA;EACA,aAAA;EACA,oCAAA;EACA,qBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,kBAAA;AACF","sourcesContent":[".scoringFactorChartContainer {\n  display: grid;\n  grid-template-columns: 0.5fr 1fr 1fr;\n  align-items: baseline;\n  gap: 32px;\n  margin: 20px 0;\n}\n\n.scoreLabelContainer {\n  display: flex;\n  gap: 8px;\n  position: relative;\n  top: 0;\n  cursor: pointer;\n}\n\n.scoringLabel {\n  font-family: var(--font-stack-full-regular);\n  line-height: 1.5;\n  font-size: 1rem;\n  font-weight: 500;\n  color: var(--grey-color-90);\n}\n\n.singleFactorChartContainer {\n  width: 100%;\n  margin-top: 16px;\n  padding-left: 12px;\n}\n\n.averageScoreContainer {\n  margin-right: 16px;\n}\n\n.mainTitleContainer {\n  margin-bottom: 18px;\n}\n\n.titleContainer {\n  font-size: 24px;\n  font-weight: 500;\n  line-height: 32px;\n  font-family: var(--font-stack-full-medium);\n  color: var(--grey-color-90);\n}\n\n.dividerLine {\n  height: 1px;\n  margin-bottom: 24px;\n  background-color: var(--grey-color-200);\n}\n\n.singleProjectSelectionInfo {\n  width: 100%;\n  margin: 24px 0 12px;\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 32px;\n  font-family: var(--font-stack-full-medium);\n  display: grid;\n  grid-template-columns: 0.5fr 1fr 1fr;\n  align-items: baseline;\n  gap: 32px;\n}\n\n.averageScoreLabelContainer {\n  flex: 1 1 48%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-right: 32px;\n}\n\n.distributionLevelTitle {\n  width: 50%;\n}\n\n.factorChartSingleSectionContainer {\n  margin: 0 0 24px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scoringFactorChartContainer": `zk7mQn71Jj5tV0E4kcjt`,
	"scoreLabelContainer": `fEMoc0jwzCmobYDajppM`,
	"scoringLabel": `Cc2rQOPAT7e5Qqu9FHIA`,
	"singleFactorChartContainer": `OIacJH1kyThUTLUqpATL`,
	"averageScoreContainer": `XneNLkMHBgtLi8K9pldq`,
	"mainTitleContainer": `Xt_rNdVEwMNizYbDELEv`,
	"titleContainer": `Fw0Aw40WiDn9knvG9x0T`,
	"dividerLine": `N12K7vA2yY09lFX2_TEL`,
	"singleProjectSelectionInfo": `SKvMXPWWc6jlpZveTUTt`,
	"averageScoreLabelContainer": `IR9oSF6_mJOa6ngiUsfS`,
	"distributionLevelTitle": `N0maLe28HIBDz6td7ncf`,
	"factorChartSingleSectionContainer": `vhhHMETYuVS6TVaLkRDo`
};
export default ___CSS_LOADER_EXPORT___;
